import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { GridsterComponentInterface, GridsterConfig } from 'angular-gridster2';
import _ from 'lodash';
import { merge, Observable, Subject } from 'rxjs';
import { auditTime, filter, takeUntil, tap } from 'rxjs/operators';
import { GridsterService } from 'src/app/services/gridster/gridster.service';
import { BrickInstance } from 'src/app/store/dashboard/brick-wall/brick-wall.state';
import { BrickLayoutType } from '../../../samwebDescription/samweb/dashboard/brickLayoutType';
import { BrickItemChangedOnWallAction } from '../../../store/dashboard/brick-wall/brick-instances/brick-instances.actions';
import { BrickInstancesSelectors } from '../../../store/dashboard/brick-wall/brick-instances/brick-instances.selectors';
import { PilotPanelState } from '../../../store/dashboard/pilot-panel/pilot-panel.state';
import { SettingsState } from '../../../store/settings/settings.state';
import { gridDefaultValue } from './data/grid-default-values';

@Component({
   selector: 'samweb-brick-wall',
   templateUrl: './brick-wall.component.html',
   styleUrls: ['./brick-wall.component.scss'],
   changeDetection: ChangeDetectionStrategy.Default,
})
export class BrickWallComponent implements AfterViewInit, OnDestroy {
   @Input()
   public isPilotPanel: boolean;

   public options: GridsterConfig;
   public brickInstanceIds$: Observable<string[]>;
   private destroy$ = new Subject();

   constructor(private store: Store, private gridsterService: GridsterService) {
      this.options = gridDefaultValue(false);
      this.options.initCallback = (gridster: GridsterComponentInterface) => {
         this.gridsterService.register(this.isPilotPanel, gridster);
      };
      this.options.destroyCallback = (gridster: GridsterComponentInterface) => {
         this.gridsterService.unregister(this.isPilotPanel);
      };
   }

   ngAfterViewInit(): void {
      this.brickInstanceIds$ = this.store.select(BrickInstancesSelectors.brickInstanceIdsForBrickWall(this.isPilotPanel));

      this.options = gridDefaultValue(this.isPilotPanel);
      this.options.itemChangeCallback = (item, itemComponent) => {
         const brickId = ((item as unknown) as BrickInstance).brickInstanceId;
         this.store.dispatch(new BrickItemChangedOnWallAction(brickId, item, this.isPilotPanel ? BrickLayoutType.PILOT_PANEL : BrickLayoutType.DEFAULT_WALL));
      };

      const marginChange$ = this.store.select(SettingsState.getBrickWallMargin).pipe(
         filter(() => !this.isPilotPanel),
         tap((margin: number) => (this.options.margin = margin))
      );

      merge(
         this.store.select(PilotPanelState.isPilotPanelExtended),
         this.store.select(BrickInstancesSelectors.brickInstanceIdsForBrickWall(this.isPilotPanel)),
         this.store.select(BrickInstancesSelectors.isBrickWallEditable),
         this.store.select(BrickInstancesSelectors.brickWallCurrentInstances),
         marginChange$
      )
         .pipe(
            auditTime(50),
            tap(() => {
               if (_.isNil(this.options.api)) {
                  return;
               }
               setTimeout(() => {
                  console.debug('optionsChanged and resize');
                  this.options.api.optionsChanged();
                  this.options.api.resize();
               }, 0);
            }),
            takeUntil(this.destroy$)
         )
         .subscribe();
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
